var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"width":"1078","is-show-header":false}},[_c('div',{staticClass:"chart-container"},[_c('Timeline'),_c('Content')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }